import { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, Label, Input, ModalHeader } from 'reactstrap';
import { QUESTION } from '@constants/terminology';
import { storeAIProcessingData } from './utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  initiativeId: string;
}

export const ExcludeAIProcessingWarning = ({ isOpen, onClose, onConfirm, initiativeId }: Props) => {
  const [dontRemindAgain, setDontRemindAgain] = useState(false);

  const handleConfirm = () => {
    if (dontRemindAgain) {
      storeAIProcessingData(initiativeId, { notShowAgain: true });
    }
    onConfirm();
  };

  const handleCheckboxChange = () => {
    setDontRemindAgain((prev) => !prev);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} backdrop='static' centered>
      <ModalHeader toggle={onClose} className='ps-3 pe-4 py-2'>
        <span className='text-md text-ThemeTextMedium'>Warning</span>
      </ModalHeader>
      <ModalBody className='p-3'>
        <p>
          Be advised: If you stop the metric data from AI processing, then AI-generated powerpoints will show no data
          and AI summaries of these metrics in combined reports will be affected. (This change can be undone).
        </p>
        <div className='mt-3'>
          <Label className='d-flex align-items-center m-0'>
            <Input type='checkbox' checked={dontRemindAgain} onChange={handleCheckboxChange} className='mt-0 me-2' />
            Don't remind me again
          </Label>
        </div>
      </ModalBody>
      <ModalFooter className='px-3 pt-0 pb-3'>
        <Button color='primary' className='px-2' onClick={handleConfirm}>
          {`Block ${QUESTION.SINGULAR} from AI processing`}
        </Button>
        <Button color='secondary' className='px-2' onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
